//export const API_URL = process.env.REACT_APP_GGC_API;
//export const API_BASE_URL = process.env.REACT_APP_GGC_API+'/api';

export const API_URL = window.REACT_APP_GGC_API;
export const API_BASE_URL = API_URL + '/api';

export const XMARTLAB_API = process.env.REACT_APP_XMARTLAB_API;
export const LEGAL_URL = process.env.REACT_APP_LEGAL_URL;

//export const TASK_V2_GET_CASES_CREATE_INFO = API_BASE_URL + "/Cases/Create/Info";

export const TASK_V2_GET_CASES_CREATE_INFO = process.env.REACT_APP_TASK_V2_GET_CASES_CREATE_INFO;

export const TASK_V2_GETINFO = process.env.REACT_APP_TASK_V2_GETINFO;
export const TASK_V2_GETACCIONS = process.env.REACT_APP_TASK_V2_GETACCIONS;
export const TASK_V2_GETSUBTASK = process.env.REACT_APP_TASK_V2_GETSUBTASK;
export const TASK_V2_ADDSUBTASK = process.env.REACT_APP_TASK_V2_ADDSUBTASK;
export const TASK_V2_GETNOMENCLATURES = process.env.REACT_APP_TASK_V2_GETNOMENCLATURES;
export const TASK_V2_GETTEMPLATE = process.env.REACT_APP_TASK_V2_GETTEMPLATE;
export const TASK_V2_GET_WORKFLOW = process.env.REACT_APP_TASK_V2_GET_WORKFLOW;
export const TASK_V2_CREATETEMPLATE = process.env.REACT_APP_TASK_V2_CREATETEMPLATE;
export const TASK_V2_UPDATETEMPLATE = process.env.REACT_APP_TASK_V2_UPDATETEMPLATE;
export const TASK_V2_GETDOCUMENTS = process.env.REACT_APP_TASK_V2_GETDOCUMENTS;
export const TASK_V2_GET_USERS_CHARGE = process.env.REACT_APP_TASK_V2_GET_USERS_CHARGE;
export const LEGAL_GET_ALL_USERS = process.env.REACT_APP_LEGAL_GET_ALL_USERS;
export const TASK_V2_GETTRIBUNALES = process.env.REACT_APP_TASK_V2_GETTRIBUNALES;
export const TASK_V1_POST_CASES_ADD = process.env.REACT_APP_TASK_V1_POST_CASES_ADD;
export const MAILS_SEND_CLIENT = process.env.REACT_APP_MAILS_SEND_CLIENT;
export const TOKEN_LEGAL365 = process.env.REACT_APP_TOKEN_LEGAL365;

export const SHOW_WORKFLOW = process.env.REACT_APP_SHOW_WORKFLOW === 'true';

window.messagesAxios = {
    loginStart: "Ingresando al Generador Contratos 365",
    loginSuccess: "Ingreso exitoso, Bienvenido",
    loginError: "Error al iniciar sesion, comuniquese con el Administrador",
    getListUsersStart: "Obteniendo usuarios de Generador Contratos 365",
    getListUsersSuccess: "Listado ObtenidoCorrectamente",
    getListUsersError: "Error al obtener los usuarios, comuniquese con el Administrador",
    getListTasksUserStart: "Obteniendo tareas del usuario",
};

window.message = {
    welcome: "Bienvenido Generador Contratos 365",
};